/**
 * アプリ共通設定
 */

/** @license Bootstrap Icons v1.10.3
 * The MIT License (MIT)
 *
 * Copyright (c) 2019-2021 The Bootstrap Authors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy 
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */


const APIURLBase = import.meta.env.VITE_APP_API_ENDPOINT;

const config = {
  MaxCID: 99,
  MaxGID: 99,
  MaxTAG: 999,
  MAX_ATTRENRAKUGROUPDAYS: 31,  // 登降園連絡最大日数

  APIURLBase: APIURLBase,
  APIURLV2Base: import.meta.env.VITE_APP_API_ENDPOINT_V2,
};


export {
  config as default
};
